module.exports = __webpack_public_path__ + "img/Footer.06ce1dc.jpeg";